export default function PageDashboard() {
	return null;
}
